import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';

export const PageTitle = () => {
  const { mleReducer } = useSelector(state => state);

  return (
    <Helmet>
      {
        mleReducer && (
          // eslint-disable-next-line max-len
          <title>{`${mleReducer.name ? `${mleReducer.name} - ` : ''}Assessments - Mathletics`}</title>
        )
      }
    </Helmet>
  );
};
